<script>
    import Header from "../header.svelte"
    import { push, pop, querystring } from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";
    import { onMount } from "svelte";
    import { toast_message } from "../../utils/toast_message.js";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { init_data } from "../../init.js";
    import { api_host, all_users_store, expense_category_store } from "../../stores.js";


    const { auth_type, auth_token, domain_code } = getToken();

    let is_busy = false;
    let content_title = "Expense - Edit";
    let eid = 0;
    let expense = {};
    let all_clients = [];
    let all_vendors = [];
    let expense_categories = [];

    let fields = [
        {
            "index": 0,
            "group": "row1",
            "type": "date",
            "label": "Date",
            "value": '',
            "name": "expense[date]",
            "validation_function": () => {
                if (fields[0].value.length > 0) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Invalid Date';
                    return false;
                }
            }
        },
        {
            "index": 1,
            "group": "row1",
            "type": "select",
            "label": "Expense Account",
            "value": "",
            "select_options": [],
            "validation_function": () => {
                if (fields[1].value.length > 0) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'Invalid Date';
                    return false;
                }
            }
        },
        {
            "index": 2,
            "group": "row2",
            "type": "select",
            "label": "Client",
            "value": "",
            "select_options": []
        },
        {
            "index": 3,
            "group": "row2",
            "type": "select",
            "label": "Vendor",
            "value": "",
            "select_options": [],
            "validation_function": () => {
                if (fields[3].value.length > 0) {
                    fields[3]['show_error'] = false;
                    return true;
                } else {
                    fields[3]['show_error'] = true;
                    fields[3]['error_text'] = 'Vendor is required';
                    return false;
                }
            }
        },
        {
            "index": 4,
            "group": "row1",
            "type": "text",
            "label": "Amount $",
            "value": "",
            "placeholder": "eg. 100",
            "validation_function": () => {
                if (parseFloat(fields[4].value) > 0) {
                    fields[4]['show_error'] = false;
                    return true;
                } else {
                    fields[4]['show_error'] = true;
                    fields[4]['error_text'] = 'Amount is required';
                    return false;
                }
            },
        },
        {
            "index": 5,
            "group": "row3",
            "type": "textarea",
            "label": "Description",
            "value": "",
            "maxlength": 200,
            "word_count_limit": 200,
            "disabled": false
        },
    ];

    all_users_store.subscribe(value => {
        let clients = [];
        let _all_clients = [];
        let vendors = [];
        let _all_vendors = [];
        for (let i = 0; i < value.length; i ++) {
            const { first_name, last_name, email, role } = value[i];
            if (role === 'client') {
                clients.push(`${first_name} ${last_name} (${email})`);
                _all_clients.push(value[i]);
            }
            if (role === 'vendor') {
                vendors.push(`${first_name} ${last_name}`);
                _all_vendors.push(value[i]);
            }
        }
        fields[2].select_options = [...[''], ...clients];
        all_clients = _all_clients;
        fields[3].select_options = [...[''], ...vendors];
        all_vendors = _all_vendors;
    });
    expense_category_store.subscribe(value => {
        let expense_accounts = [];
        let _expense_categories = [];
        for (let i = 0; i < value.length; i ++) {
            const { account_name } = value[i];
            expense_accounts.push(account_name);
            _expense_categories.push(value[i]);
        }
        fields[1].select_options = expense_accounts;
        fields[1].value = expense_accounts[0];
        expense_categories = _expense_categories;
    });

    onMount(async () => {
        init_data('expense_category');

        const params = new URLSearchParams($querystring);

        if (params.has("eid")) {
            is_busy = true;
            eid = params.get("eid");
            const res = await doFetch(
                `${api_host}/api/expense/get/${eid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                expense = res.expense;
                const { bill_date, vendor_name, amount, description, expense_category, client_name } = expense;
                fields[0].value = bill_date;
                fields[1].value = expense_category;
                fields[2].value = client_name ? client_name : '';
                fields[3].value = vendor_name;
                fields[4].value = amount;
                fields[5].value = description;
            }
            else { toast_message(false, res.msg || 'Fetching expense failed', 3000); }
            is_busy = false;
        }
    });

    let validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (field.validation_function && !field.validation_function()) {
                is_valid = false;
            }
        });
        return is_valid;
    };

    async function updateExpense() {
        if (validateForm()) {
            const client = all_clients.filter(_client => `${_client.first_name} ${_client.last_name} (${_client.email})` === fields[2].value);
            const vendor = all_vendors.filter(_vendor => `${_vendor.first_name} ${_vendor.last_name}` === fields[3].value);
            const expense_category = expense_categories.filter(category => category.account_name === fields[1].value);
            const payload = {
                'expense_id': expense.id,
                'bill_date': fields[0].value,
                'expense_account_name': fields[1].value,
                'category_id': expense_category[0] ? expense_category[0].id : 0,
                'client': fields[2].value,
                'client_id': client[0] ? client[0].hoy_user : 0,
                'vendor': fields[3].value,
                'vendor_id': vendor[0] ? vendor[0].hoy_user : 0,
                'amount': fields[4].value,
                'description': fields[5].value
            };
            is_busy = true;
            const res = await doFetch(
                `${api_host}/api/expense/update`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 3000);
                init_data('expenses');
                push('#/Accountingexpenses');
            } else {
                toast_message(false, res.msg || 'Bad request', 3000);
            }
            is_busy = false;
        } else {
            toast_message(false, 'Missing or invalid info', 3000);
        }
    }
</script>


<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section">
        <div class="addexpenseholder">
            <div class="toolsholder">
                {#each fields.filter((e) => e.group === "row1") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:validation_function={nf.validation_function}
                        bind:change_function={nf.change_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                {/each}
            </div>

            <div class="toolsholder">
                {#each fields.filter((e) => e.group === "row2") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:validation_function={nf.validation_function}
                        bind:change_function={nf.change_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                {/each}
            </div>

            <div class="toolsholder">
                {#each fields.filter((e) => e.group === "row3") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        maxlength={nf.maxlength}
                        word_count_limit={nf.word_count_limit}
                        bind:disabled={nf.disabled}
                        bind:value={nf.value}
                        bind:validation_function={nf.validation_function}
                        bind:change_function={nf.change_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                {/each}
            </div>

            <div class="newexpensebuttonholder">
                <button class="savebutton" on:click={() => {updateExpense("new_expense");}}>
                    <i class="fas fa-save"></i> Save
                </button>
                &nbsp;&nbsp;
                <button class="cancelbutton" on:click={() => {pop();}}>
                    <i class="fas fa-window-close"></i> Back
                </button>
            </div>
        </div>
    </div>
</div>


<style>
    .contentholder {
        width: 100%;
    }
    .newexpensebuttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .newexpensebuttonholder button{
        padding-left: 25px;
        padding-right: 25px;
    }
    .newexpensebuttonholder button.savebutton{
         background-color: #1c54b2;
         color: white;
    }
    .newexpensebuttonholder button.cancelbutton{
        background-color: #b2102f;
        color: white;
    }
    :global(.rowwrap .group) {
        min-width: 300px;
        max-width: 300px;
    }
    .toolsholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }
    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .toolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }
        .newexpensebuttonholder {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: start;
        }
        .newexpensebuttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }
    }
</style>